import { FC, PropsWithChildren, useEffect } from "react";
import useEvent from "react-use-event-hook";

import { DrawerType, Log } from "@ryde/shared";

import { MobileFiltersDrawer } from "../../drawers";

interface IPageHeadersFiltersMobileSidebar extends PropsWithChildren {
  mainTitle: string;
  onApply: () => void;
  setIsFilterSidebarOpen: (value: boolean) => void;
}

export const PageHeadersFiltersMobileSidebar: FC<
  IPageHeadersFiltersMobileSidebar
> = ({ setIsFilterSidebarOpen, mainTitle, onApply, children }) => {
  const resetFilterValues = useEvent((): void => {
    Log.debug(`Cleanup map data`);
  });
  useEffect(() => {
    return () => resetFilterValues();
  }, [resetFilterValues]);

  const closeSidebar = useEvent((): void => {
    setIsFilterSidebarOpen(false);
  });

  return (
    <MobileFiltersDrawer
      title={mainTitle}
      onCloseDrawer={closeSidebar}
      type={DrawerType.EditForm}
    >
      {children}
    </MobileFiltersDrawer>
  );
};
